import { all, fork } from 'redux-saga/effects';

/**
* Se registran cada watcher inyectado en createStore
*/

export const makeRootSaga = (sagas) => {
  return function *rootSaga () {
    yield all(sagas.map(saga => fork(saga)));
  };
};

export const injectSagas = (store, {key, sagas}) => {
  if (store.asyncSagas[key]) {
    return;
  }
  store.asyncSagas[key] = sagas;
  store.runSaga(makeRootSaga(sagas));
};

export default makeRootSaga;



// WEBPACK FOOTER //
// ./src/store/sagas.js